import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { z } from 'zod'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { CreateDefectNotice } from '../../../common/validations/defectNotice'
import { ErrorResponse } from '../../../common/validations'
import { ResidentAppError } from '../../../common/error'

import { patch } from 'api/apiClient'

export const useAPIPatchDefectNotice = (
  defectNoticeUuid: string,
  options?: UseMutationOptions<unknown, ErrorResponse, CreateDefectNotice>
) => {
  const { isError, isPending, mutate } = useMutation({
    mutationFn: (data) =>
      patch(
        API_ENDPOINTS.EDIT_DEFECT_NOTICE.replace(
          ':contractUuid',
          data.contractUuid
        ).replace(':defectNoticeUuid', `${defectNoticeUuid}`),
        data,
        z.object({})
      ),
    retry: 1,
    throwOnError: false,
    ...options,
  })

  if (isError) {
    throw ResidentAppError.ClientError('DEFECT_NOTICE_SUBMIT_ERROR')
  }

  return {
    submit: mutate,
    isSubmitting: isPending,
  }
}
